import { login, getInfo, logout } from '@api/login'
import {
  getToken,
  setToken,
  removeToken,
  setAccount,
  setPassword,
  removeAccount,
  removePassword,
  setRole,
} from '@utils/auth'
import {
  SET_TOKEN,
  SET_USER_INFO,
  SET_WID,
  SET_TRAINER_INFO,
  SET_SHOW_TRAINER_WECHAT,
} from '../mutation-types'
import { SUCCESS } from '@src/constant/request'
import { encryption } from '@/utils/crypto'
import { AccountType } from '@/constant/user'

const user = {
  state: {
    token: getToken(),
    userInfo: {
      roles: [],
    },
    wid: '',
    twQrcode: '', // 训练师微信
    phone: '', // 训练师电话
    showTrainerWechat: false,
  },
  getters: {
    hid: state => state.userInfo.hid,
    age: state => state.userInfo.age,
    gender: state => state.userInfo.gender,
    uid: state => state.userInfo.sdxUid,
    pid: state => state.userInfo.pid,
    name: state => state.userInfo.name,
    role: state => state.userInfo.role,
    openDay: state => state.userInfo.openDay,
    usedDay: state => state.userInfo.usedDay,
    dailyTrainDuration: state => state.userInfo.dailyTrainDuration,
    singleTrainDuration: state => state.userInfo.singleTrainDuration,
    twQrcode: state => state.userInfo.twQrcode,
    phone: state => state.userInfo.phone,
    address: state => state.userInfo.address,
    renewalQrCode: state => state.userInfo.renewalQrCode,
    avgLoadTime: state => state.userInfo.avgLoadTime,
    isExpire: state => {
      return (
        (new Date().getTime() - new Date(state.userInfo.expireDate).getTime() >
          0 ||
          state.userInfo.openDay - state.userInfo.usedDay === 0) &&
        [AccountType.BASIS, AccountType.ADVANCED, AccountType.MYOPIA].includes(
          state.userInfo.role
        )
      )
    },
  },
  mutations: {
    [SET_TOKEN](state, token) {
      state.token = token
    },
    [SET_USER_INFO](state, userInfo) {
      state.userInfo = userInfo
    },
    [SET_WID](state, wid) {
      state.wid = wid
    },
    [SET_TRAINER_INFO](state, data) {
      state.twQrcode = data.twQrcode
      state.phone = data.phone
    },
    [SET_SHOW_TRAINER_WECHAT](state, showTrainerWechat) {
      state.showTrainerWechat = showTrainerWechat
    },
  },
  actions: {
    async Login({ commit }, loginInfo) {
      const user = encryption({
        data: loginInfo,
        encryptArr: ['password'],
      })
      try {
        const res = await login({
          account: user.account.trim(),
          password: user.password,
        })
        if (res.code === SUCCESS) {
          if (loginInfo.remember) {
            setAccount(loginInfo.account.trim())
            setPassword(loginInfo.password)
          } else {
            removeAccount()
            removePassword()
          }
          commit(SET_TOKEN, res.data.token)
          setToken(res.data.token)
        }
      } catch (error) {
        console.log(error)
        return Promise.reject(error)
      }
    },
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        ;(async () => {
          try {
            const userInfo = await getInfo()
            commit(SET_USER_INFO, userInfo)
            setRole(userInfo.role)
            resolve(userInfo)
          } catch (error) {
            console.log(error)
            reject(error)
          }
        })()
      })
    },
    Logout({ commit }) {
      return new Promise((resolve, reject) => {
        ;(async () => {
          try {
            await logout()
            commit(SET_TOKEN, '')
            removeToken()
            resolve()
          } catch (error) {
            console.log(error)
            reject(error)
          }
        })()
      })
    },
    FeLogout({ commit }) {
      return new Promise(resolve => {
        commit(SET_TOKEN, '')
        removeToken()
        resolve()
      })
    },
  },
}

export default user
